export default __webpack_public_path__ + "static/media/mallory_compact_bold_italic.fc60069b.ttf";